import { match } from 'ts-pattern';
import { getIdSequence } from '@salsita-ai/platform-project-sdk/domain';
import { BurnerBaseW24Variant, Handing, LynxProfessionalGrillVariant, LynxSinkBase } from '../__generated/model/versions/v10.js';
// V10 changes:
//  - add new entity LynxNapoliPizzaOven
//  - join LoweredBurnerBaseW24 with BurnerBaseW24
//  - rename LynxProfessionalGrill variants (AllCeramic -> RotisserieOnly, TridentAndCeramic -> TridentAndRotisserie)
//  - split SinkBase into LynxSinkBase (for Lynx sink appliances) and SinkBase (for empty bases)
export const migrateToV10 = (state)=>{
    const sequence = getIdSequence(state, []);
    // Helper to check if an appliance is a Lynx sink
    const isLynxSinkAppliance = (applianceId)=>{
        if (!applianceId) {
            return false;
        }
        const appliance = state.find((e)=>e.id === applianceId);
        if (!appliance) {
            return false;
        }
        return appliance.type === 'LynxSinkW18' || appliance.type === 'LynxSinkW24' || appliance.type === 'LynxSinkW30' || appliance.type === 'LynxProfessionalCocktailStation';
    };
    return state.map((entity)=>{
        return match(entity).returnType().with({
            type: 'LoweredBurnerBaseW24'
        }, (entity)=>({
                ...entity,
                id: sequence.nextId('BurnerBaseW24'),
                type: 'BurnerBaseW24',
                variant: BurnerBaseW24Variant.Lowered,
                handing: Handing.top
            })).with({
            type: 'BurnerBaseW24'
        }, (entity)=>({
                ...entity,
                variant: BurnerBaseW24Variant.CounterTopHeight
            })).with({
            type: 'SinkBase'
        }, (entity)=>{
            // Convert to LynxSinkBase if it has a Lynx sink appliance
            if (isLynxSinkAppliance(entity.applianceId)) {
                return {
                    ...entity,
                    id: sequence.nextId('LynxSinkBase'),
                    type: LynxSinkBase.type
                };
            }
            // Otherwise keep as SinkBase
            return entity;
        }).with({
            type: 'LynxProfessionalGrillW30'
        }, {
            type: 'LynxProfessionalGrillW36'
        }, {
            type: 'LynxProfessionalGrillW42'
        }, {
            type: 'LynxProfessionalGrillW54'
        }, (entity)=>({
                ...entity,
                variant: entity.variant === 'AllCeramic' ? LynxProfessionalGrillVariant.RotisserieOnly : entity.variant === 'TridentAndCeramic' ? LynxProfessionalGrillVariant.TridentAndRotisserie : entity.variant
            })).otherwise((other)=>other);
    });
};

//# sourceMappingURL=v10.js.map